import { format } from "date-fns";

export const getOrderReportDateRange = (startDate: Date, endDate: Date) => ({
  startDate: format(startDate, "yyyy-MM-dd"),
  endDate: format(endDate, "yyyy-MM-dd"),
});

export const mapOrderReportExportRows = (rows: any[] = []) =>
  rows.map((row: any) => ({
    Reference: row?.Reference || "",
    Mode: row?.Mode || row?.mode || row?.Type || "",
    Customer: row?.["Customer name"] || "",
    Origin: row?.["Origin branch"] || "",
    Destination: row?.["Destination branch"] || "",
  }));
